export default {
  id: "StudentTable",
  code: "CN",
  text: {
    "Credit": "钱包余额",
    'Used/Purchased': '已消耗/已购买',
    'Used/Paid': '已消耗/已缴学费',
    'Setup': '未设置',

    'Archive Student': '转为历史学员',
    'This student has paid tuition or credit, do you wish to refund?': '此学员已缴费或有钱包余额，是否要退费？',
    'Discounted': '折扣',

    'Archive Students': '批量转为历史学员',
    'Archived': '历史学员',

    'Sort by': '排序',
    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
    'First Name: A-Z': '按名：由A到Z',
    'First Name: Z-A': '按名：由Z到A',
    'Last Name: A-Z': '按姓：由A到Z',
    'Last Name: Z-A': '按姓：由Z到A',
    'Upgrade': '升级'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/locale.js